// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WyznZ","textarea":"styles_textarea__3qB9z"};